import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import HostRequestsApi from './HostRequestsApi';
import HostRequestsActions from './Components/HostRequestsActions';

let settings;

export default settings = {
    key: 'hosts/requests',
    zone: 'hosts',
    path: '/hosts/requests',
    title: "Host Requests",
    endpoint: HostRequestsApi.endpoint,
    modelName: 'HostRequests',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewHostRequests"],
    viewCaps: ["viewHostRequests"],
    createCaps: ["createHostRequests"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path
            },
            {
                label: "Pending",
                path: settings.path + "/status/pending",
            },
            {
                label: "Resolved",
                path: settings.path + "/status/resolved",
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: HostRequestsApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['host', 'property'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['subject'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Status",
                key: "status",
                type: 'choice',
                options: [
                    { label: "Pending", value: "pending" },
                    { label: "Resolved", value: "resolved" },
                ]
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Request ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Subject",
                key: "subject",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            {
                label: "Property",
                key: "property",
                format: "ModelLink",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <HostRequestsActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: HostRequestsApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['host', 'property'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};